import Rollbar from 'rollbar'

const isProduction = process.env.NODE_ENV === 'production'
const env = process.env.FRONTEND_ROLLBAR_ENV || process.env.NODE_ENV
const rollbarKey = document
  ?.getElementsByName('rollbarFEKey')?.[0]
  ?.getAttribute('content')

export default new Rollbar({
  accessToken: rollbarKey,
  enabled: isProduction,
  payload: {
    environment: env,
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  },
  // Just to be sure that the user is using updated UI
  code_version: '1.0.0'
})
